import gql from '@/services/gql';
import * as priceFragments from '@/services/price/fragments';

export const update = gql(`
  mutation update_product(
    $objects: [product_insert_input!]!
    $componentIds: [uuid!]
    $materialIds: [uuid!]
    ${priceFragments.mutationArgs}
  ) {
    ${priceFragments.mutations}

    insert_product(
      objects: $objects
      on_conflict: {
        constraint: product_pkey
        update_columns: [
          care_instructions
          care_symbols
          name
          notes
          properties
          resource_costs
          sizes
        ]
      }
    ) {
      affected_rows
      returning {
        id
      }
    }

    delete_product_component(
      where: {
        id: {
          _in: $componentIds
        }
      }
    ) {
      affected_rows
      returning {
        id
      }
    }

    delete_product_material(
      where: {
        id: {
          _in: $materialIds
        }
      }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`);

export default {
  update,
};
